import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/nuxt/layouts/default.vue").then(m => m.default || m)),
  "home-design": defineAsyncComponent(() => import("/app/nuxt/layouts/home-design.vue").then(m => m.default || m))
}